export default __webpack_public_path__ + "static/media/ytLogo.8709f215.png";